import React from 'react';
import { DialogComponent } from '../../../../Components';
import { ButtonBase, DialogActions } from '@material-ui/core';
import { showError, showSuccess } from '../../../../Helper';
import { useTranslation } from 'react-i18next';
import { DeleteAward } from '../../../../Services/AwardServices';

function DeleteUserAward({
  isOpen,
  translationPath,
  setIsDeleteDialogOpen,
  activeAward,
  refetchData,
}) {
  const { t } = useTranslation(translationPath);

  async function onDeleteClicked() {
    const res = await DeleteAward(activeAward.awardId);

    if (!(res && res.status && res.status !== 200)) {
      await refetchData();
      showSuccess(t('award-deleted-successfully'));
      setIsDeleteDialogOpen(false);
    } else {
      showError(t('award-deletion-failed'));
    }
  }

  return (
    <DialogComponent
      isOpen={isOpen}
      titleText={t('delete-award')}
      maxWidth='sm'
      dialogContent={
        <>
          <div>
            <p>{t('are-you-sure-you-want-to-delete-this-user-award')}</p>
            <p>{t('this-action-cant-be-reversed')}</p>

            <DialogActions>
              <ButtonBase
                onClick={() => {
                  setIsDeleteDialogOpen(false);
                }}
                className={`btns theme-solid bg-cancel`}
              >
                {t(`cancel`)}
              </ButtonBase>
              <ButtonBase
                className={`btns theme-solid bg-danger`}
                onClick={() => {
                  onDeleteClicked();
                }}
              >
                {t(`confirm`)}
              </ButtonBase>
            </DialogActions>
          </div>
        </>
      }
      translationPath={''}
      parentTranslationPath={translationPath}
    />
  );
}

export default DeleteUserAward;
